module.exports = __webpack_public_path__ + "static/img/team.8a55c57.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/team/team.jpg
// module id = aARw
// module chunks = 7